export default "__VITE_ASSET__o4CH9QEZ__"